import React from 'react'
import useBlog, { selectors as blogSelectors } from 'publisher/hooks/useBlog'
import {
  MobileOnloadPopup,
  OnloadPopup,
} from 'publisher/pages/components/onload-popups'
import { useManagement, usePage } from 'publisher/store'
import managementSelectors from 'publisher/store/management/managementSelectors'
import pageSelectors from 'publisher/store/page/pageSelectors'

/**
 * The main difference between this component and OnloadPopups
 * is that we could have popups from blog layout
 * and we need to create a "close cookie" with layout page id
 */
export const BlogOnloadPopups = () => {
  const desktopOnloadPopups = usePage(pageSelectors.getOnloadPopups)
  // mobile onload it is a "mobile on exit" option actually
  const mobileOnloadPopups = usePage(pageSelectors.getMobileOnloadPopups)
  // we could have global popups available on all pages and posts
  const blogLayoutPageId = useBlog(blogSelectors.getBlogLayoutPageId)
  const isMobile = useManagement(managementSelectors.isMobile)

  const renderedDesktopOnLoadPopups = desktopOnloadPopups.map(popup => (
    <OnloadPopup pageId={blogLayoutPageId} key={popup.id} popup={popup} />
  ))

  if (typeof window !== 'undefined' && isMobile) {
    return (
      <>
        {mobileOnloadPopups
          .map(popup => (
            <MobileOnloadPopup
              pageId={blogLayoutPageId}
              key={popup.id}
              popup={popup}
            />
          ))
          .concat(renderedDesktopOnLoadPopups)}
      </>
    )
  } else {
    return <>{renderedDesktopOnLoadPopups}</>
  }
}
